import React, { useState, useCallback, useEffect } from "react";
import { connect } from "dva";
import {
  EmployeeAttribute,
  FileChatMessage,
  RosterApplyStatus,
  Session,
  SessionType,
  UID
} from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import ChatState from "@/types/chat/State";
import { WithTranslation } from "react-i18next";
import IconFont from "@/components/icon";
import { Drawer, List, Tabs } from "antd";
import { getGroupDongRead } from "@/api/chat";
import { ListItem } from "@jd/focus-desktop-comps";
import { ListItemData } from "@/components/ListItem";
import DefaultPage from "@/components/DefaultPage";
import dayjs from "dayjs";
import InfiniteScroll from "react-infinite-scroller";
import Loading from "@/components/Loading";
import { CompDataLoadState, DefaultPageType } from "@/models";
import { getUnitTitleInfo, isSameClient } from "@/utils/chat/message";
import { isFocusEnv } from "@/utils";
import { changeEgovUrl } from "@/utils/tools";
import bus from "@/utils/bus";
import { getUserAlias } from "@/utils/chat/group";
import { CrossTag } from "@/components/Tags";
import "./MessageDongReadStatusBtn.less";
import ImService from "@/server/ImService";

interface UploadFileProps {
  isMergeForward?: boolean;
  message: FileChatMessage;
  sendType: MessageSendType;
  sessionType: SessionType;
  selectedSession?: Session;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
}

interface DvaDispatchProps {
  updateSessionMessageMid: Function;
}
type IProps = Readonly<WithTranslation & UploadFileProps & DvaDispatchProps & ChatState>;

interface BaseData {
  fileId: string;
  downloadPeopleCount: number;
  downloadCount: number;
}

function MessageDongReadStatusBtn(props: IProps) {
  const { message, selectedSession } = props;
  const [detailVisible, setDetailVisible] = useState(false);
  const [dataList, setDataList] = useState<ListItemData[]>([]);
  const [readMemberList, setReadMemberList] = useState<EmployeeAttribute[]>([]);
  const [unReadMemberList, setUnReadMemberList] = useState<EmployeeAttribute[]>([]);
  const [fetching, setFetching] = useState(false);
  const [fetched, setFetched] = useState(false);

  const fetchDataList = useCallback(async () => {
    if (fetching) return;
    setFetching(true);
    getGroupDongRead({
      mid: String(message.mid),
      gid: message.sessionId
    }).then(async (res) => {
      console.log(res, "getGroupDongRead");
      if (res[0]) {
        const data = res[0];
        // const noAvatarList: {
        //   appId: string;
        //   teamId: string;
        //   userId: string;
        // }[] = data.readMmemberList;
        const imService = ImService.getInstance();
        const unReadMemberList = await imService.getChangeUserDetailList(
          data.unReadMemberList.map((item) => ({
            userId: item.pin,
            teamId: item.teamId,
            appId: item.app
          }))
        );

        const readMemberList = await imService.getChangeUserDetailList(
          data.readMemberList.map((item) => ({
            userId: item.pin,
            teamId: item.teamId,
            appId: item.app
          }))
        );
        console.log("unReadMemberList=>", unReadMemberList);
        console.log("readMemberList=>", readMemberList);
        setReadMemberList(readMemberList);
        setUnReadMemberList(unReadMemberList);
      }
      setFetching(false);
      setFetched(true);
    });
  }, [fetching, message.mid, message.sessionId]);

  const visibleChange = (e: MouseEvent) => {
    if (detailVisible) {
      bus.emit("message-item-chatitem", true);
    }
  };
  useEffect(() => {
    document.addEventListener("contextmenu", visibleChange);
    return () => {
      document.removeEventListener("contextmenu", visibleChange);
    };
  });

  const showDetailModal = () => {
    setDetailVisible(true);
    fetchDataList();
  };

  const handleClose = () => {
    setDetailVisible(false);
    setReadMemberList([]);
    setUnReadMemberList([]);
  };

  return (
    <>
      <div className="extend-btn" onClick={showDetailModal}>
        <span>阅读状态</span>
        <IconFont
          type="iconapp_ic_details"
          style={{
            fontSize: "11px",
            color: "rgba(22,134,255,.6)",
            height: "18px",
            lineHeight: "22px"
          }}
        />
      </div>
      <Drawer
        title={
          <div className="drawer-title">
            <span className="drawer-title_name">阅读状态</span>
          </div>
        }
        className="upload-detail-drawer"
        placement="right"
        width={340}
        onClose={handleClose}
        visible={detailVisible}
        destroyOnClose={true}
        maskClosable={true}
      >
        <Tabs className="message-dong-read-tabs">
          <Tabs.TabPane tab={`未读（${unReadMemberList.length}）`} key="unread">
            <div className="upload-detail-content">
              {!fetched ? (
                <div className="detail-loading-wrap">
                  <Loading type="message" />
                </div>
              ) : unReadMemberList.length ? (
                <div className="upload-detail-list">
                  <List
                    dataSource={unReadMemberList || []}
                    renderItem={(item) => {
                      const alias = getUserAlias(
                        { ...item, app: item.app || "gwork" },
                        selectedSession,
                        "hideRemark"
                      );
                      // const isExternal =
                      //   item.userType === "1" || item.userType === "4" || item.userType === "5";
                      const nameStr = alias ? `${item.name}（${alias}` : `${item.name}`;
                      let newItem = {
                        ...item,
                        name: nameStr,
                        desc: getUnitTitleInfo(item.unitName, item.titleName),
                        ...{
                          avatar: changeEgovUrl(item.avatar)
                          // externalTag: isExternal && <CrossTag />
                        }
                      };
                      return (
                        <ListItem
                          data={newItem}
                          className="upload-detail-item"
                          // tag={isExternal && <CrossTag />}
                        />
                      );
                    }}
                  />
                </div>
              ) : (
                <DefaultPage
                  dataType={CompDataLoadState.NODATA}
                  pageType={DefaultPageType.KEYWORD}
                  description="暂无数据"
                />
              )}
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab={`已读（${readMemberList.length}）`} key="read">
            <div className="upload-detail-content">
              {!fetched ? (
                <div className="detail-loading-wrap">
                  <Loading type="message" />
                </div>
              ) : readMemberList.length ? (
                <div className="upload-detail-list">
                  <List
                    dataSource={readMemberList || []}
                    renderItem={(item) => {
                      const alias = getUserAlias(
                        { ...item, app: item.app || "gwork" },
                        selectedSession,
                        "hideRemark"
                      );
                      // const isExternal =
                      //   item.userType === "1" || item.userType === "4" || item.userType === "5";
                      const nameStr = alias ? `${item.name}（${alias}` : `${item.name}`;
                      let newItem = {
                        ...item,
                        name: nameStr,
                        desc: getUnitTitleInfo(item.unitName, item.titleName),
                        ...{
                          avatar: changeEgovUrl(item.avatar)
                          // externalTag: isExternal && <CrossTag />
                        }
                      };
                      return (
                        <ListItem
                          data={newItem}
                          className="upload-detail-item"
                          // tag={isExternal && <CrossTag />}
                        />
                      );
                    }}
                  />
                </div>
              ) : (
                <DefaultPage
                  dataType={CompDataLoadState.NODATA}
                  pageType={DefaultPageType.KEYWORD}
                  description="暂无数据"
                />
              )}
            </div>
          </Tabs.TabPane>
        </Tabs>
      </Drawer>
    </>
  );
}

function mapStateToProps({ chat }: any) {
  const { selectedSession } = chat as ChatState;
  return { selectedSession };
}

export default connect(mapStateToProps)(MessageDongReadStatusBtn);
